import { Box, Button, Typography } from "@mui/material";
import { QrCode } from "lucide-react";
import {} from "react-bootstrap";
import { useTranslation } from "react-i18next";

export const HeaderComponent = ({
  title,
  export_fn,
  setShow,
  setGenerate,
  buttonName,
  className
}) => {
    const { t, i18n } = useTranslation();
    const isAr = i18n.language === 'ar';

  const getPageTitle = () => {
    const titleText = t(`admin_titles.${title}`);
    // Handle the case of there is no room name. just diplay "Students" instead of "students_of_class"
    if (title === "students_of_class" && !className){
      return t(`admin_titles.students`);
    }
    return className ? `${titleText} ${className}` : titleText;
  };

  return (
    <div className="d-flex justify-content-between py-4">
      <Box sx={{ display: "flex", gap: 3 }}>
        <Typography variant="h4">{getPageTitle()}</Typography>
        {setGenerate && (
          <Button
            onClick={() => setGenerate(true)}
            variant="contained"
            startIcon={<QrCode />}
            sx={{
              borderRadius: "50px",
              px: 3,
              fontSize: "0.8125em",
              textTransform: "None",
            }}
          >
            {isAr ? "  توليد رمز QR" : "Generate QR Code"}
          </Button>
        )}
      </Box>
      <div>
        {/* Use short-circuit evaluation to show the button only if export_fn exists */}
        {export_fn && (
          <Button
            onClick={export_fn}
            sx={{
              fontSize: "0.8125em",
              px: 3,
              py: 1,
              textTransform: "None",
            }}
          >
            {t("buttons.export_csv")}
          </Button>
        )}


        {/* Only show export button if export_fn is provided */}
        {setShow  && (
        <Button
          onClick={() => setShow(true)}
          variant="contained"
          sx={{
            borderRadius: "50px",
            fontSize: "0.8125em",
            px: 3,
            py: 1,
            textTransform: "None",
          }}
        >
          {t(`buttons.${buttonName}`)}
        </Button>)}
      </div>
    </div>
  );
};
